import { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";
import { Modal } from "@circle-react-uikit/ModalV2";
import { Typography } from "@circle-react-uikit/Typography";
import { I18N_LOCALE_ROOT } from "./constants";

interface SuccessStateProps {
  currentPlan?: string;
  onClose: () => void;
  planName?: string;
  trialEndDate?: string;
}

export const SuccessState = ({
  planName = "Business",
  onClose,
  currentPlan = "Professional",
  trialEndDate,
}: SuccessStateProps) => (
  <>
    <Modal.Body className="px-12 py-8">
      <div className="mx-auto max-w-sm text-center">
        <div className="mb-6 flex justify-center">
          <Typography.TitleXxl>
            {t(`${I18N_LOCALE_ROOT}.success.icon`)}
          </Typography.TitleXxl>
        </div>

        <div className="mb-4">
          <Typography.TitleLg color="text-darkest">
            {t(`${I18N_LOCALE_ROOT}.success.title`)}
          </Typography.TitleLg>
        </div>

        <div>
          <Typography.BodyMd
            color="text-subtle"
            weight="normal"
            size="text-base"
            leading="leading-relaxed"
          >
            {t(`${I18N_LOCALE_ROOT}.success.subtitle`, {
              planName,
              currentPlan,
              trialEndDate: trialEndDate || "30 days",
            })}
          </Typography.BodyMd>
        </div>
      </div>
    </Modal.Body>

    <Modal.Footer className="border-t-0 px-12 pb-8 pt-0">
      <div className="flex justify-center">
        <Button
          variant="primary"
          large
          onClick={onClose}
          className="min-w-[200px]"
        >
          {t(`${I18N_LOCALE_ROOT}.success.button`)}
        </Button>
      </div>
    </Modal.Footer>
  </>
);
